import { isAxiosError } from 'axios';

export function getHttpErrorStatusCode(err: unknown): number | undefined {
  if (isAxiosError(err)) return err.response?.status;
  if (typeof err === 'object' && err !== null && 'response' in err) {
    return (err as { response?: { status?: number } }).response?.status;
  }
  return undefined;
}

export function isHttpConflictError(err: unknown): boolean {
  return getHttpErrorStatusCode(err) === 409;
}

export function getHttpErrorExceptionMessage(err: unknown): string | undefined {
  if (isAxiosError(err)) {
    const message = err.response?.data?.error?.exceptionMessage;
    return typeof message === 'string' && message.trim() ? message : undefined;
  }
  if (typeof err === 'object' && err !== null && 'response' in err) {
    const message = (err as { response?: { data?: { error?: { exceptionMessage?: string } } } }).response?.data
      ?.error?.exceptionMessage;
    return typeof message === 'string' && message.trim() ? message : undefined;
  }
  return undefined;
}
